import { desc, eq, sql } from "drizzle-orm";
import { Link, redirect } from "react-router";
import { z } from "zod";
import { requireSess } from "~/auth.server";
import { CharacterList } from "~/components/metrika/CharacterList";
import { Icon32 } from "~/components/ui/Icon";
import { PageTitle } from "~/components/ui/PageTitle";
import { Table } from "~/components/ui/Table";
import { pg } from "~/pg.server";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { logPageView } from "~/util/stats";

const PageQuery = z.object({
  date: z.optional(z.string()),
});

$PAGE({
  path: "tracker",
  loader: $LOADER?.(async (args) => {
    // Log
    logPageView(args);
    //
    const sess = requireSess(args.req.sess);

    const subscription = await pg.db
      .select({ subscriptionExpiry: pg.subscriptions.endsAt })
      .from(pg.subscriptions)
      .where(eq(pg.subscriptions.userId, sess.user.id))
      .then((res) => res.at(0));

    if (!subscription) {
      return redirect("/subscription");
    }

    const characterResult = await pg.db
      .select({
        id: pg.tkChars.id,
        name: pg.tkChars.charName,
      })
      .from(pg.tkChars)
      .where(eq(pg.tkChars.userId, sess.user.id))
      .limit(500);
    // const recentActiveCharacters = await pg.db
    //   .select({
    //     id: pg.tkCharacters.id,
    //     name: pg.tkCharacters.name,
    //     value: sql<
    //       string[]
    //     >`ARRAY_AGG(DISTINCT DATE_TRUNC('day', ${pg.tkLoot.timestamp})::text)`,
    //   })
    //   .from(pg.tkCharacters)
    //   .leftJoin(pg.tkLoot, eq(pg.tkCharacters.id, pg.tkLoot.characterId))
    //   .where(eq(pg.tkLoot.itemId, -1))
    //   .groupBy(pg.tkCharacters.id)
    //   .orderBy(pg.tkLoot.timestamp)
    //   .limit(10);
    // console.log(recentActiveCharacters);

    return { characters: characterResult, authUser: args.req.sess?.user };
  }),
  meta: (args) => {
    const title = "Tracker";

    return {
      title: `${title} - L2Hub`,
      description: "Tracker L2Hub",
    };
  },
  render: ({ data }) => {
    return (
      <div>
        <div className="content">
          <div className="columns">
            <div className="column is-three-quarters">
              <PageTitle>Characters</PageTitle>
              {/* <pre>{JSON.stringify(data.recentActiveCharacters, null, 2)}</pre> */}
              {/* {data.recentActiveCharacters.map((char, i) => <div key={i}>{char.name}</div>)} */}
              {/* <CharacterList data={data.characters} /> */}
            </div>
            <div className="column"></div>
          </div>
        </div>
        <Table
          data={data.characters}
          id={(char) => char.id}
          cols={[
            {
              title: "",
              cell: (char) => <Icon32 icon="unknown" />,
              thPadding: "0",
              padding: "8px 0 8px 8px",
              width: 32 + 12,
            },
            {
              title: "Name",
              cell: (char) => (
                <Link to={`/tracker/${char.id}/stats`}>{char.name}</Link>
              ),
            },
          ]}
        />
      </div>
    );
  },
});
